// Comparison cluster — srovnávací stránky pro rozhodování. Neútočí na konkurenci, pomáhají vybrat.
import { mkIntent } from "./intents";

export const COMPARISONS = [
  mkIntent({
    slug: "jednodenni-vs-dvoudenni-teambuilding",
    breadcrumb: "Jednodenní vs dvoudenní",
    overline: "POROVNÁNÍ FORMÁTŮ",
    title: "Jednodenní vs dvoudenní teambuilding | Co se vyplatí?",
    description: "Jednodenní nebo dvoudenní firemní teambuilding? Poctivé porovnání formátů Mission (4–6 h) a Mission 24 (24 hodin s noclehem): cena, program, pro koho.",
    h1: "Jednodenní vs dvoudenní teambuilding: poctivé porovnání",
    heroSub: "Oba formáty mají stejnou misi na Ještěd. Liší se vším ostatním — a právě v tom ostatním je rozdíl mezi výletem a zážitkem.",
    img: "dinner",
    answerQ: "Jednodenní nebo dvoudenní teambuilding — co zvolit?",
    answerShort: "Jednodenní Mission (od 2 490 Kč/os.) dává smysl pro firmy z blízkého okolí Liberce a kratší časové okno. Dvoudenní Mission 24 (od 4 990 Kč/os.) pro všechny ostatní — nocleh, večeře a party promění akci v zážitek, který tým opravdu spojí.",
    answerDetail: [
      "Pravidlo z praxe: dojezd nad hodinu = dvoudenní formát. Dojezd do 40 minut = jednodenní stačí, party lze dokoupit.",
      "Rozdíl v ceně za osobu je cca 2 500 Kč — za nocleh, večeři, snídani, soukromý klub s DJ a fotografa.",
    ],
    sections: [
      {
        kicker: "JEDNODENNÍ MISSION",
        heading: "Když stačí jeden den",
        list: [
          "4–6 hodin: briefing, mise, finish, vyhlášení",
          "Bez noclehu — večer je každý doma",
          "Od 2 490 Kč na osobu",
          "Ideální pro Liberec, Jablonec, Turnov, Českou Lípu",
          "Večerní Warehouse lze dokoupit",
        ],
        paras: [],
      },
      {
        kicker: "MISSION 24",
        heading: "Když má akce něco znamenat",
        list: [
          "24 hodin: mise + večeře + vyhlášení + soukromá party + nocleh + snídaně",
          "Od 4 990 Kč na osobu (min. 129 000 Kč za akci)",
          "Fotograf po celou akci v ceně",
          "Žádné odjíždění po programu — tým zůstává pohromadě",
          "Ideální pro Prahu a vzdálenější města",
        ],
        paras: [
          "Největší rozdíl není v programu, ale v tom, co si tým odnese. Společná noc po misi dělá z kolegů tým víc než jakýkoliv workshop.",
        ],
      },
    ],
    faq: [
      { q: "O kolik je dvoudenní dražší?", a: "Mission 24 vychází orientačně o 2 500 Kč na osobu dráž než jednodenní Mission. V ceně je nocleh, večeře, snídaně, soukromá party s DJ a fotograf." },
      { q: "Lze jednodenní misi rozšířit o večer?", a: "Ano — večeře a soukromý Warehouse s DJ umíme k jednodenní Mission dokoupit. Pak chybí jen nocleh a snídaně." },
      { q: "Co když část týmu nemůže přenocovat?", a: "Není problém. Nocleh využije, kdo chce — cenu akce to významně nemění, protože venue, DJ a fotograf jsou fixní položky." },
    ],
    related: [
      { href: "/jednodenni-teambuilding", title: "Jednodenní teambuilding", text: "Mission bez noclehu." },
      { href: "/dvoudenni-teambuilding", title: "Dvoudenní teambuilding", text: "Mission 24 detail." },
      { href: "/teambuilding-s-ubytovanim-vs-bez-ubytovani", title: "S ubytováním vs bez", text: "Další porovnání." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-vs-firemni-vecirek",
    breadcrumb: "Teambuilding vs večírek",
    overline: "POROVNÁNÍ",
    title: "Teambuilding vs firemní večírek | Proč nejlepší je kombinace",
    description: "Teambuilding nebo firemní večírek? Porovnání obou formátů a proč Mission Ještěd kombinuje obojí: odpolední týmová mise + večerní soukromá party.",
    h1: "Teambuilding vs firemní večírek? Špatná otázka. Správná je: proč ne obojí",
    heroSub: "Mission Ještěd vznikla právě proto, že oba formáty samostatně selhávají: teambuildingy bývají nudné, večírky prázdné. My spojujeme misi s party.",
    img: "finishDrink",
    answerQ: "Jaký je rozdíl mezi teambuildingem a firemním večírkem?",
    answerShort: "Teambuilding má cíl (spolupráce, zkušenost týmu), večírek má atmosféru (oslavu, volnost). Samostatný teambuilding končí odjezdem, samostatný večírek začíná u baru bez společného příběhu. Mission 24 kombinuje obojí: odpoledne mise, večer soukromá party.",
    answerDetail: [
      "Firemní večírek bez společného zážitku = lidé se baví v bublinách oddělení. Po misi se baví přes ně — odpoledne je totiž rozházela do týmů a dala jim společné historky.",
      "Cenově: Mission 24 (mise + party + nocleh) od 4 990 Kč/os. vychází levněji než agenturní teambuilding + večírek v pronajatém sále zvlášť.",
    ],
    sections: [
      {
        kicker: "KDY SAMOSTATNÝ VEČÍREK",
        heading: "Večírek stačí, když…",
        paras: [
          "…jde čistě o oslavu (výročí, Vánoce) a firma za rok absolvovala jiný rozvojový program. I pak ale zvažte formát 'mise light + party' — dává večeru téma.",
          "Soukromý Warehouse umíme připravit i jako samostatný večerní formát pro liberecké firmy.",
        ],
      },
      {
        kicker: "KDY KOMBINACE",
        heading: "Kombinace, když…",
        list: [
          "Chcete, aby si lidé z mise odnesli společný zážitek",
          "Večírek má mít téma a energii od první minuty",
          "Firma platí dopravu — ať za to něco stojí",
          "Chcete jednoho dodavatele za celý den i večer",
        ],
        paras: [],
      },
    ],
    faq: [
      { q: "Umíte i jen firemní večírek bez mise?", a: "Primárně prodáváme kompletní mise. Samostatný večerní Warehouse řešíme individuálně, hlavně pro firmy z Liberce a okolí." },
      { q: "Co když část týmu nechce sportovat?", a: "Fyzickou část lze u jednotlivců vynechat — čekají je role na checkpointech a večerní program. Nikdo není vyloučen." },
      { q: "Jak spojit misi s vánočním večírkem?", a: "Prosincová Mission 24 s vánoční večeří a party ve Warehouse je přesně tento formát. Termíny doporučujeme poptat do konce září." },
    ],
    related: [
      { href: "/teambuilding-s-party", title: "Teambuilding s party", text: "Mise + soukromý klub." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub detail." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-s-ubytovanim-vs-bez-ubytovani",
    breadcrumb: "S ubytováním vs bez",
    overline: "POROVNÁNÍ",
    title: "Teambuilding s ubytováním vs bez ubytování | Kdy se nocleh vyplatí",
    description: "Teambuilding s ubytováním nebo bez? Pravidla z praxe: dojezd, večerní program, rozpočet a co nocleh změní na atmosféře akce. Ceny obou variant.",
    h1: "Teambuilding s ubytováním nebo bez? Tři otázky, které rozhodnou",
    heroSub: "Nocleh není luxus navíc — je to rozdíl mezi akcí, ze které se večer rozpadáváte k autům, a akcí, která končí společnou snídaní.",
    img: "warehouseExterior",
    answerQ: "Vyplatí se teambuilding s ubytováním?",
    answerShort: "Ano, pokud je dojezd nad hodinu, pokud chcete večerní program s alkoholem, nebo pokud má akce tým skutečně spojit. Bez ubytování dává smysl jednodenní Mission pro firmy z blízkého okolí Liberce.",
    answerDetail: [
      "Nocleh v rámci Mission 24 stojí v přepočtu málo: rozdíl mezi jednodenní Mission a Mission 24 je cca 2 500 Kč/os. — a v tom je nocleh, večeře, snídaně, party i fotograf.",
      "S ubytováním odpadá nejhorší část firemních akcí: hlídání odjezdů a řidičů.",
    ],
    sections: [
      {
        kicker: "TŘI OTÁZKY",
        heading: "Rozhodovací pravidla",
        list: [
          "Dojezd nad 60 minut? → s ubytováním",
          "Večerní program s alkoholem? → s ubytováním",
          "Rozpočet pod 3 000 Kč/os. a firma z okolí Liberce? → bez ubytování stačí",
        ],
        paras: [
          "U skupin 20–50 lidí je nocleh logisticky jednoduchý — kapacitu držíme ověřenou tak, aby byl tým pohromadě.",
        ],
      },
      {
        kicker: "CO NOCI ZMĚNÍ",
        heading: "Proč tým vzpomíná na noc, ne na misi",
        paras: [
          "Mise je sdílený výkon, ale vztahy se staví večer a ráno. U společné snídaně se probírají historky, vznikají přezdívky a plánuje další rok.",
          "Z HR pohledu: dvoudenní formát má výrazně vyšší účast — lidé se těší na zážitek, ne na povinnost.",
        ],
      },
    ],
    faq: [
      { q: "Kde tým spí?", a: "V ověřené kapacitě v Liberci a okolí Ještědu — vždy tak, aby byl tým pohromadě. Konkrétní objekt potvrdíme v nabídce podle termínu." },
      { q: "Kolik stojí varianta s ubytováním navíc?", a: "Mission 24 (s noclehem) od 4 990 Kč/os. vs jednodenní Mission od 2 490 Kč/os. Rozdíl cca 2 500 Kč/os. pokrývá nocleh, večeři, snídani, party i fotografa." },
      { q: "Co když někdo přenocovat nemůže?", a: "Není problém — odjede po večerním programu. Cenu akce to podstatně nemění." },
    ],
    related: [
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mission 24 detail." },
      { href: "/jednodenni-vs-dvoudenni-teambuilding", title: "Jednodenní vs dvoudenní", text: "Porovnání formátů." },
      { href: "/ubytovani", title: "Ubytování", text: "Jak řešíme nocleh." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
];
